import { useCallback, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/typedReduxHooks'
import { setWorkLocationProfileId } from '../../../pages/NewScriptPage/ScriptForm/PrescriberSlice'
import { usePrescriberLocationProfiles } from '../hooks/usePrescriberLocationProfiles'
import { SelectLocationModal } from './SelectLocationModal'
import { JoinLocationModal } from './JoinLocationModal'

export const InitLocationModal = () => {
  const [view, setView] = useState<'select' | 'join'>('select')

  const dispatch = useAppDispatch()
  const prescriber = useAppSelector((s) => s.prescriber.prescriber)
  const authentication = useAppSelector((s) => s.authentication)
  const workLocationProfileId = useAppSelector((s) => s.prescriber.workLocationProfileId)

  const isLoggedIn = Boolean(authentication?.userId)
  const skipQueries = !isLoggedIn || Boolean(workLocationProfileId)

  const { joinedPrescriberLocationProfiles, availableLocations, isLoading } =
    usePrescriberLocationProfiles(skipQueries)

  const prescriberName = useMemo(() => {
    if (!prescriber) return ''
    return `${prescriber.givenNames ?? ''} ${prescriber.familyName ?? ''}`.trim()
  }, [prescriber])

  const handleSelectLocation = useCallback(
    (locationProfileId: string) => {
      dispatch(setWorkLocationProfileId(locationProfileId))
    },
    [dispatch]
  )

  if (!isLoggedIn || workLocationProfileId || isLoading) return null

  return (
    <>
      {view === 'select' && (
        <SelectLocationModal
          isOpen={true}
          joinedPrescriberLocationProfiles={joinedPrescriberLocationProfiles}
          prescriberName={prescriberName}
          title={prescriber?.title ?? ''}
          prescriberNumber={prescriber?.prescriberNumber ?? ''}
          onSelect={handleSelectLocation}
          onJoinNew={() => setView('join')}
        />
      )}
      {view === 'join' && (
        <JoinLocationModal
          isOpen={true}
          onClose={() => setView('select')}
          availableLocations={availableLocations}
          hideCloseButton={true}
          onBack={() => setView('select')}
        />
      )}
    </>
  )
}
